import styled, { css } from 'styled-components';

export const NotificationContainer = styled.div<any>`
  position: absolute;
  display: flex;
  z-index: 3;
  left: 50%;
  vertical-align: middle;
  text-align: center;
  height: 50px;
  padding: 0 15px;
  align-items: center;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.colors.defaultNavy};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 3px;
  bottom: 0px;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transform: translate(
    -50%,
    ${({ isVisible }) => (isVisible ? '-20px' : '50px')}
  );
  transition: transform 180ms ease-in-out;
`;

export const NotificationComponentContainer = styled.div`
  ${({ theme }) => theme.mixins.fontWeights.book};

  display: flex;
  align-items: center;
`;

export const NotificationIconPadding = css`
  padding-right: 18px;
`;

export const IconContainer = styled.div`
  display: inline-block;
  margin-right: 15px;

  .hv-svg svg {
    height: 14px;
    width: 14px;

    path {
      fill: ${({ color }) => color};
    }
  }
`;
